import MenuService from "../../services/MenuService";
import {ProductService} from "../../services/ProductService";
import {FoodService} from "../../services/FoodService";

const menuService = new MenuService();

let paginate = {
    rowsPerPage: 50,
    sortBy: 'created_at',
    descending: true,
};

const state = {
    menus: {
        data: [],
    },
    currentEditedMenu: null,
    currentScaleMenu: null,
    ownProductsCount: 0,
    ownFoodsCount: 0,
};

const getters = {
    menus: state => state.menus,
    currentEditedMenu: state => state.currentEditedMenu,
    currentScaleMenu: state => state.currentScaleMenu,
    ownProductsCount: state => state.ownProductsCount,
    ownFoodsCount: state => state.ownFoodsCount,
};

const mutations = {
    setMenus: (state, menus) => (state.menus = menus),
    setCurrentEditedMenu: (state, currentEditedMenu) => (state.currentEditedMenu = currentEditedMenu !== null ? Object.assign({}, currentEditedMenu) : null),
    setCurrentScaleMenu: (state, currentScaleMenu) => (state.currentScaleMenu = currentScaleMenu !== null ? Object.assign({}, currentScaleMenu) : null),
    setOwnProductsCount: (state, ownProductsCount) => (state.ownProductsCount = ownProductsCount),
    setOwnFoodsCount: (state, ownFoodsCount) => (state.ownFoodsCount = ownFoodsCount),
};

const actions = {
    async fetchMenus({commit}, query) {
        const requestQuery = query !== null && query.hasOwnProperty('params') ? query.params : paginate;
        paginate = requestQuery;

        const {data} = await menuService.fetchMenus(query.patientId, requestQuery);
        commit('setMenus', data);
    },
    setCurrentEditedMenu({commit}, menu) {
        commit('setCurrentEditedMenu', menu);
    },
    setCurrentScaleMenu({commit}, menu) {
        commit('setCurrentScaleMenu', menu);
    },
    async fetchOwnProductsCount({commit}) {
        const {data} = await ProductService.fetchOwnProductsCount();
        commit('setOwnProductsCount', data.count);
    },
    async fetchOwnFoodsCount({commit}) {
        commit('setOwnFoodsCount', await FoodService.fetchOwnFoodsCount());
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
